import * as AT from './_types.js'

export const notifyConvos = convoIds => ({
  type: AT.FETCH_ALL_UNSEEN_CONVOS,
  convoIds,
})

export const addUnseenConvoId = convoId => ({
  type: AT.ADD_UNSEEN_CONVO,
  convoId,
})

export const removeUnseenConvoId = convoId => ({
  type: AT.REMOVE_UNSEEN_CONVO,
  convoId,
})



// WEBPACK FOOTER //
// ./src/state/actions/notifications.js